import React, { ReactElement, FunctionComponent, useRef } from 'react'
import { TestID } from '../utils/PropTypesDefinitions'
import RevolverPlayCountdownPortrait from './Portrait'
import RevolverPlayCountdownLandscape from './Landscape'

export type RevolverplayCountdownProps = {
    isPortrait: boolean
    onFinish: () => void
} & TestID

const RevolverPlayCountdown: FunctionComponent<RevolverplayCountdownProps> = ({
    isPortrait,
    onFinish,
    testID,
}): ReactElement => {
    const [seconds, setSeconds] = React.useState(5)
    const interval = useRef<number>()

    React.useEffect(() => {
        if (seconds <= 0) {
            clearInterval(interval.current)
        }
    }, [seconds])

    React.useEffect(() => {
        interval.current = window.setInterval((): void => {
            setSeconds(seconds => seconds - 1)
        }, 1000)
    }, [])

    return isPortrait ? (
        <RevolverPlayCountdownPortrait seconds={seconds} onFinish={onFinish} testID={testID} />
    ) : (
        <RevolverPlayCountdownLandscape seconds={seconds} onFinish={onFinish} testID={testID} />
    )
}

export default RevolverPlayCountdown
